import styled from "styled-components";

export const RecaptchaWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

export const ForgotPassword = styled.a`
  color: ${({ theme }) => theme.colors.primary.prim50};
  ${({ theme }) => theme.font.body.sm};
  text-decoration: none;

  cursor: pointer;
`;

export const Selector = styled.div`
  display: flex;
  justify-content: space-between;
`;
